import styled from 'styled-components'

import { breakpoint } from 'utils'

//Components
import Panel from '../Panel'
import { ButtonUnstyled } from 'components/Button'

export const Text = styled.p`
  line-height: 1.5;
  font-size: 0.875rem;
`

export const CheckboxWrapper = styled.div`
  display: flex;
  justify-content: flex-end;

  ${breakpoint('base', 'xs')`
    margin-top: 16px;
    justify-content: flex-start;
  `}
`

export const StyledPanelTitle = styled(Panel.Title)`
  display: flex;

  ${breakpoint('base', 'xs')`
    flex-direction: column;
    align-items: flex-start;
  `}

  /* Hack to fix the Button presentation in IE11 */
  & ${ButtonUnstyled} {
    flex-shrink: 0;
    display: inline;
  }
`
